import { Stack, styled } from '@mui/material'

export const StyledStack = styled(Stack)`
  height: 24px;
  display: flex;
  justify-content: center;
`
